var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"system-log-modal"},[_c('vue-friendly-iframe',{staticClass:"system-log-modal__iframe",attrs:{"src":_vm.iframeSrc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }